// extracted by mini-css-extract-plugin
export default {"description":"b1Byesw1","buttons":"zeHycrXw","button":"sWhesqmk"};